// src/components/Expertise.js
import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

// Update the expertiseData to include organized tags
const expertiseData = [
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 12h2M7 6v12M12 3v18M17 6v12M20 10v4"></path>
      </svg>
    ),
    title: "AI Systems & Voice Agents",
    description: "I build and deploy AI into the funnel: voice agents that capture and qualify leads 24/7, CRM automation, prompt engineering, custom MCP integrations, and data pipelines that eliminate manual operations at scale.",
    gradient: "primary",
    tags: ["Voice AI", "Prompt Engineering", "CRM Automation", "MCP Integrations"]
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"></path>
      </svg>
    ),
    title: "Multi-Channel Advertising",
    description: "Strategic campaign architecture across Google, Meta, LinkedIn, TikTok, Native, and Programmatic networks. Expert in scaling campaigns from $10k to $500k+ monthly spend while maintaining performance.",
    gradient: "accent",
    tags: ["Paid Media", "Lead Generation", "Funnel Optimization", "Audience Segmentation"]
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
        <circle cx="8.5" cy="8.5" r="1.5"></circle>
        <polyline points="21 15 16 10 5 21"></polyline>
      </svg>
    ),
    title: "Modern Website Design",
    description: "Crafting immersive digital experiences with cutting-edge technologies and design principles. Specializing in responsive, conversion-focused websites that blend stunning aesthetics with strategic functionality to elevate brand presence and drive business results.",
    gradient: "primary",
    tags: ["UI/UX Design", "Responsive Design", "Conversion Optimization", "Brand Experience"]
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
        <polyline points="17 6 23 6 23 12"></polyline>
      </svg>
    ),
    title: "Growth Marketing",
    description: "Data-driven acquisition frameworks for scaling businesses. Proven record of implementing comprehensive tracking, audience development strategies, and conversion optimization across industries.",
    gradient: "secondary",
    tags: ["Digital Transformation", "Marketing Operations", "Tech Infrastructure", "Performance Scaling"]
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
        <circle cx="9" cy="7" r="4"></circle>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
      </svg>
    ),
    title: "Lead Generation Systems",
    description: "Sophisticated lead generation architectures for legal, financial, and technology sectors using GoHighLevel, HubSpot, and LeadsHook. Expert in qualification flows, lead scoring, and CRM integration that converts traffic into qualified prospects.",
    gradient: "primary",
    tags: ["Funnel Architecture", "CRM Integration", "Lead Qualification", "Multi-Platform Advertising"]
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"></path>
        <line x1="2" y1="20" x2="2.01" y2="20"></line>
      </svg>
    ),
    title: "Marketing Automation",
    description: "End-to-end automation systems using HubSpot, GoHighLevel, and LeadsHook that nurture relationships, qualify leads, and drive conversions with personalized messaging. Expert in building custom integration workflows with Zapier and server-side systems.",
    gradient: "accent",
    tags: ["Email Automation", "Lead Nurturing", "Workflow Design", "System Integration"]
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5z"></path>
        <path d="M20.5 10H19V8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"></path>
        <path d="M9.5 14c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5S8 21.33 8 20.5v-5c0-.83.67-1.5 1.5-1.5z"></path>
        <path d="M3.5 14H5v1.5c0 .83-.67 1.5-1.5 1.5S2 16.33 2 15.5 2.67 14 3.5 14z"></path>
        <path d="M14 14.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5z"></path>
        <path d="M15.5 19H14v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"></path>
        <path d="M10 9.5C10 8.67 9.33 8 8.5 8h-5C2.67 8 2 8.67 2 9.5S2.67 11 3.5 11h5c.83 0 1.5-.67 1.5-1.5z"></path>
        <path d="M8.5 5H10V3.5C10 2.67 9.33 2 8.5 2S7 2.67 7 3.5 7.67 5 8.5 5z"></path>
      </svg>
    ),
    title: "Marketing Infrastructure",
    description: "Comprehensive tracking and measurement systems that capture the full customer journey using Meta Pixel, CAPI, GA4, and GTM. Expert in transitioning external operations to robust in-house marketing capabilities.",
    gradient: "secondary",
    tags: ["Tracking Architecture", "Data Pipeline", "Attribution Modeling", "Conversion Events"]
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M5 7h14M5 12h14M5 17h14"></path>
        <line x1="4" y1="22" x2="20" y2="22"></line>
      </svg>
    ),
    title: "Analytics & Insights",
    description: "Data-driven decision making with comprehensive analytics setups that track customer journeys, identify opportunities, and measure ROI across digital marketing initiatives using Mixpanel, GA4, and platform analytics.",
    gradient: "accent",
    tags: ["Campaign Analytics", "Performance Reporting", "Customer Journey", "ROI Analysis"]
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
        <line x1="8" y1="21" x2="16" y2="21"></line>
        <line x1="12" y1="17" x2="12" y2="21"></line>
      </svg>
    ),
    title: "Funnel Optimization",
    description: "Strategic design and optimization of conversion funnels that guide prospects from awareness to conversion. Expert in A/B testing, landing page optimization, and multi-step qualification flows.",
    gradient: "primary",
    tags: ["A/B Testing", "Landing Page Design", "User Experience", "Conversion Rate"]
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="7"></rect>
        <rect x="14" y="3" width="7" height="7"></rect>
        <rect x="14" y="14" width="7" height="7"></rect>
        <rect x="3" y="14" width="7" height="7"></rect>
      </svg>
    ),
    title: "Training & Enablement",
    description: "Comprehensive training and knowledge transfer programs that empower marketing teams with technical skills and strategic capabilities. Specialized in digital advertising platform education and implementation.",
    gradient: "secondary",
    tags: ["Team Training", "Knowledge Transfer", "Capability Building", "Process Design"]
  }
];

const Expertise = () => {
  // Animation variants for the entire section
  const sectionVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        when: "beforeChildren",
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };
  
  // Animation variants for individual cards
  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.215, 0.61, 0.355, 1]
      }
    }
  };
  
  // Track when section is in view
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  
  return (
    <ExpertiseSection id="expertise">
      <Container>
        <SectionHeader
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6 }}
        >
          <Eyebrow>What I do</Eyebrow>
          <Title className="gradient-text-accent">My Expertise</Title>
          <Divider className={`gradient-bg-accent`} />
          <Description>
            From performance marketing to AI systems — I help businesses build acquisition channels that compound, then automate them so they run themselves.
          </Description>
        </SectionHeader>
        
        <ExpertiseGrid
          ref={ref}
          as={motion.div}
          variants={sectionVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          {expertiseData.map((item, index) => (
            <ExpertiseCard
              key={index}
              as={motion.div}
              variants={cardVariants}
              whileHover={{ y: -10, boxShadow: "0 20px 40px rgba(0, 0, 0, 0.25)" }}
              className="bg-glass"
              featured={index === 0} // Make the AI Systems card stand out
            >
              <ExpertiseIcon className={`gradient-bg-${item.gradient}`}>
                {item.icon}
              </ExpertiseIcon>
              <ExpertiseTitle className={`gradient-text-${item.gradient}`}>
                {item.title}
              </ExpertiseTitle>
              <ExpertiseDescription>
                {item.description}
              </ExpertiseDescription>
              
              {/* Organized Tags/Pills Grid */}
              <TagsGrid>
                {item.tags.map((tag, idx) => (
                  <Tag key={idx} gradient={item.gradient}>
                    {tag}
                  </Tag>
                ))}
              </TagsGrid>
            </ExpertiseCard>
          ))}
        </ExpertiseGrid>
      </Container>
    </ExpertiseSection>
  );
};

const ExpertiseSection = styled.section`
  padding: 6rem 0;
  background: ${({ theme }) => theme.colors.darker};
  position: relative;
  overflow: hidden;
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle at 15% 50%, rgba(99, 102, 241, 0.08), transparent 25%),
                radial-gradient(circle at 85% 30%, rgba(236, 72, 153, 0.08), transparent 25%);
    pointer-events: none;
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 4rem 0;
  }
`;

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 2rem;
  position: relative;
  z-index: 1;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0 1.5rem;
  }
`;

const SectionHeader = styled(motion.div)`
  margin-bottom: 4rem;
  text-align: center;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const Eyebrow = styled.div`
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #f59e0b;
  margin-bottom: 0.85rem;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 2rem;
  }
`;

const Divider = styled.div`
  width: 6rem;
  height: 4px;
  border-radius: 2px;
  margin: 0 auto 1.5rem;
`;

const Description = styled.p`
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 1.125rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 1rem;
  }
`;

const ExpertiseGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    grid-template-columns: 1fr;
  }
`;

const ExpertiseCard = styled.div`
  padding: 2.5rem 2rem;
  height: 100%;
  transition: all ${({ theme }) => theme.transitions.slow};
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  
  /* Make the featured card stand out */
  ${({ featured }) => featured && `
    border-top: 3px solid #ec4899;
    transform: scale(1.02);
    
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(180deg, rgba(236, 72, 153, 0.05) 0%, rgba(0, 0, 0, 0) 100%);
      z-index: -1;
      border-radius: inherit;
    }
  `}
  
  &:hover {
    transform: translateY(-8px) ${({ featured }) => featured ? 'scale(1.03)' : ''};
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  }
`;

const ExpertiseIcon = styled.div`
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  
  svg {
    width: 1.75rem;
    height: 1.75rem;
    color: white;
  }
`;

const ExpertiseTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
`;

const ExpertiseDescription = styled.p`
  color: ${({ theme }) => theme.colors.textSecondary};
  margin-bottom: 1.5rem;
  flex-grow: 1; /* Makes description take up available space */
`;

// New organized Tags Grid
const TagsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;
  margin-top: auto; /* Push tags to bottom of card */
  
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    grid-template-columns: 1fr; /* Single column on mobile */
  }
`;

// Styled Tag component
const Tag = styled.span`
  padding: 0.4rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 500;
  color: white;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme, gradient }) => {
    switch(gradient) {
      case 'primary':
        return 'rgba(99, 102, 241, 0.2)';
      case 'secondary':
        return 'rgba(16, 185, 129, 0.2)';
      case 'accent':
        return 'rgba(239, 68, 68, 0.2)';
      default:
        return 'rgba(99, 102, 241, 0.2)';
    }
  }};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  min-height: 28px;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    white-space: normal; /* Allow text wrapping on mobile */
  }
`;

export default Expertise;